module.exports = __webpack_public_path__ + "img/red_truck_big.4cbf7c8d.svg";